// Bow is already deployed. Other styles activate only after the sync job has
// populated their tags and published the compact shop registry.
const headerStyleFallbackRoutes = [
  { name: 'Tab Top with Bow', tag: 'cz-header-tab-top-with-bow', terms: ['Tab Top with Bow', 'Bowtie', 'Bow Tie'] }
];

const normalizeHeaderStyle = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
const headerStyleRoutes = [...headerStyleFallbackRoutes];
const registryElement = document.getElementById('header-style-search-registry');
if (registryElement?.textContent) {
  try {
    const registry = JSON.parse(registryElement.textContent);
    if (registry?.version === 1 && Array.isArray(registry.styles)) {
      for (const style of registry.styles) {
        if (typeof style.name !== 'string' || !/^[\p{L}\p{N}][\p{L}\p{N} -]*$/u.test(style.name) ||
            typeof style.tag !== 'string' ||
            !/^cz-header-[a-z0-9-]+$/.test(style.tag)) continue;
        if (style.terms !== undefined &&
            (!Array.isArray(style.terms) || style.terms.length < 1 ||
             style.terms.some((term) => typeof term !== 'string' ||
               !term.trim() || term.length > 80))) continue;
        if (headerStyleRoutes.some((route) => route.tag === style.tag || normalizeHeaderStyle(route.name) === normalizeHeaderStyle(style.name))) continue;
        headerStyleRoutes.push({ name: style.name, tag: style.tag, terms: style.terms });
      }
    }
  } catch (_) { /* Keep the deployed Bow route if the optional registry is malformed. */ }
}

window.headerStyleSearch = {
  routes: headerStyleRoutes,
  resolve(value) {
    const normalized = normalizeHeaderStyle(value);
    return this.routes.find((route) => (route.terms || [route.name]).some((term) => normalizeHeaderStyle(term) === normalized)) || null;
  },
  queryFor(value) {
    const route = this.resolve(value);
    return route ? `tag:${route.tag}` : null;
  }
};

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form.matches('form.main-search__form')) return;
  const input = form.querySelector('input[name="q"]');
  const tagQuery = input && window.headerStyleSearch.queryFor(input.value);
  if (!tagQuery) return;
  input.value = tagQuery;
  let productType = form.querySelector('input[name="type"]');
  if (!productType) {
    productType = document.createElement('input');
    productType.type = 'hidden';
    productType.name = 'type';
    form.appendChild(productType);
  }
  productType.value = 'product';
}, true);

// Direct and bookmarked customer searches take the same exact tag route.
if (window.location.pathname.replace(/\/$/, '').endsWith('/search')) {
  const tagQuery = window.headerStyleSearch.queryFor(new URLSearchParams(window.location.search).get('q'));
  if (tagQuery) {
    const target = new URL(window.location.href);
    target.searchParams.set('q', tagQuery);
    target.searchParams.set('type', 'product');
    window.location.replace(target.href);
  }
}
